import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import buildUpdateWebhooksRows from './buildUpdateWebhooksRows.helper';

const { Box, Button, BackButton, Title, Table, TextField } = vp;

type DefaultValues = {
  accountonboarding: string;
};

type ToggleValues = {
  accountonboarding: boolean;
};

type UpdateWebhookProps = {
  defaultValues: DefaultValues;
  toggleValues: ToggleValues;
  onSubmit: () => void;
  onBack: () => void;
};
type FC = FunctionComponent<UpdateWebhookProps>;

const UpdateWebhooksReview: FC = (props: UpdateWebhookProps) => {
  const { defaultValues, toggleValues, onSubmit, onBack } = props;
  const updateWebhookRows = buildUpdateWebhooksRows();
  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ handleSubmit }) => {
        const updateWebhookTable: vp.TableProps = {
          name: 'update-webhook-fields',
          columns: {
            Field: { header: 'Event' },
            Toggle: { header: 'Enable Events', align: 'left' },
            Input: { header: 'URL' },
          },
          rows: updateWebhookRows.map(({ label, id, preset }) => ({
            Field: label,
            Toggle: (
              <div style={{ paddingLeft: '40px' }}>
                {toggleValues[id as keyof ToggleValues] === true ? 'Yes' : 'No'}
              </div>
            ),
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                onBlur={() => {}}
                onChange={() => {}}
                value={defaultValues[id as keyof DefaultValues]}
                disabled
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box mb="lg" jc="fs" ai="center" gap="common">
              <BackButton variant="arrow" backButtonEnabled onClick={onBack} />
              <Title title="Review and Save" />
            </Box>
            <Table {...updateWebhookTable} />
            <Box width="100%" jc="fe" mt="lg">
              <Button id="webhook-submit" type="submit" label="Save" />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdateWebhooksReview;
